        <p-drawer
            [visible]="visible()"
            (onHide)="onDrawerHide()"
            position="right"
            [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
            class="layout-profile-sidebar w-full sm:w-25rem"
            header="Welcome"
        >
            <div class="flex flex-col mx-auto md:mx-0">
                <span class="text-surface-500 dark:text-surface-400 font-medium text-xl mb-8">
                    {{authService.authUserComputedSignal()?.firstName}} {{authService.authUserComputedSignal()?.lastName}}
                        <span class="font-normal text-lg">
                            {{authService.authUserComputedSignal()?.email}}
                        </span>
                    </span>


                <ul class="list-none m-0 p-0">
                    <!-- <li>
                        <a
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i class="pi pi-user text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Profile</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                </p>
                            </div>
                        </a>
                    </li> -->
                    <!-- <li>
                        <a
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i
                                    class="pi pi-money-bill text-xl text-primary"
                                ></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Billing</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                </p>
                            </div>
                        </a>
                    </li> -->
                    <!-- <li>
                        <a
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i class="pi pi-cog text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Settings</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                </p>
                            </div>
                        </a>
                    </li> -->
                    <li>
                        <a
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        (click)="onConfigButtonClick()">
                            <span>
                                <i class="pi pi-palette text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">UI Theme</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                </p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        (click)="signOut()">
                            <span>
                                <i
                                    class="pi pi-power-off text-xl text-primary"
                                ></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Sign Out</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </p-drawer>